/* ==========================================================================
   ZWANZE — misc.js
   Deux petits composants : compte à rebours du drop, et chargement différé
   des recommandations produit (pour ne pas peser sur le LCP).
   ========================================================================== */
(function () {
  'use strict';

  /* --- Compte à rebours -----------------------------------------------------
     La date est rendue côté serveur ; le JS ne fait qu'afficher l'écart.
     Sans JavaScript, les tirets restent : aucune information n'est perdue,
     car la date est aussi écrite en clair dans le texte de la section. */
  class Countdown extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.date).getTime();
      if (Number.isNaN(this.target)) { this.remove(); return; }
      this.fields = {
        d: this.querySelector('[data-d]'),
        h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'),
        s: this.querySelector('[data-s]')
      };
      this._tick();
      this._timer = window.setInterval(this._tick.bind(this), 1000);
    }
    disconnectedCallback() { window.clearInterval(this._timer); }

    _tick() {
      const delta = this.target - Date.now();
      if (delta <= 0) {
        window.clearInterval(this._timer);
        this.innerHTML = '<p class="z-countdown__passed">' + (this.dataset.passed || '') + '</p>';
        return;
      }
      const seconds = Math.floor(delta / 1000);
      this._set('d', Math.floor(seconds / 86400));
      this._set('h', Math.floor(seconds / 3600) % 24);
      this._set('m', Math.floor(seconds / 60) % 60);
      this._set('s', seconds % 60);
    }
    _set(key, value) {
      if (this.fields[key]) this.fields[key].textContent = String(value).padStart(2, '0');
    }
  }
  customElements.define('z-countdown', Countdown);

  /* --- Recommandations produit ---------------------------------------------
     Chargées seulement quand la section approche de l'écran. */
  class Recommendations extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this._load();
      }, { rootMargin: '400px' }).observe(this);
    }
    async _load() {
      try {
        const response = await fetch(this.dataset.url);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('.shopify-section');
        if (section && section.innerHTML.trim()) this.innerHTML = section.innerHTML;
        else this.remove();
      } catch (error) {
        this.remove();
      }
    }
  }
  customElements.define('z-recommendations', Recommendations);
})();

/* ==========================================================================
   ZWANZE v2 — révélation au défilement et rebond du panier
   ========================================================================== */
(function () {
  'use strict';
  var Z = window.Zwanze;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Révélation des blocs -----------------------------------------------
     Le marchand peut la désactiver dans Réglages du thème > Animations ;
     dans ce cas --z-motion vaut 0 et on affiche tout immédiatement. */
  var motion = getComputedStyle(document.documentElement).getPropertyValue('--z-motion').trim();
  var items = document.querySelectorAll('.z-reveal');

  if (reduce || motion === '0' || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* --- Le cornet de frites rebondit à chaque ajout ------------------------- */
  if (Z && !reduce) {
    Z.on('cart:updated', function (event) {
      if (!event.detail || !event.detail.added) return;
      document.querySelectorAll('[data-cart-bump]').forEach(function (el) {
        el.setAttribute('data-bump', '');
        window.setTimeout(function () { el.removeAttribute('data-bump'); }, 480);
      });
    });
  }
})();

/* ==========================================================================
   Bulle de chat Tidio — dégagement du bouton d'achat mobile
   (Claude, 15/09/2026)

   Constat mesuré sur la fiche produit en 375 px : la bulle Tidio (45 px,
   coin bas droit, z-index 999999999) recouvrait 43 px du bouton
   « Ajouter au panier » de la barre collante, soit un quart de sa largeur,
   pile là où tombe le pouce d'un droitier. Un clic sur ce quart ouvrait
   le chat au lieu d'ajouter au panier.

   Correctif : on remonte la bulle de 84 px au-dessus de la barre, sur les
   fiches produit et en mobile uniquement, et seulement tant que le chat
   est FERMÉ — sinon la fenêtre de conversation plein écran serait décalée
   elle aussi. L'ouverture et la fermeture sont suivies via l'API Tidio.

   Pour annuler : supprimer ce bloc entier.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var FERME = 'z-tidio-closed';

  var style = document.createElement('style');
  style.textContent =
    '@media (max-width: 767px){' +
      'html.' + FERME + ' body.template-product #tidio-chat{' +
        'transform: translateY(-84px);' +
      '}' +
    '}';
  document.head.appendChild(style);

  root.classList.add(FERME);

  function suivreOuvertureFermeture() {
    var api = window.tidioChatApi;
    if (!api || typeof api.on !== 'function') { return false; }
    api.on('open', function () { root.classList.remove(FERME); });
    api.on('close', function () { root.classList.add(FERME); });
    return true;
  }

  if (!suivreOuvertureFermeture()) {
    document.addEventListener('tidioChat-ready', suivreOuvertureFermeture);
  }
})();
